import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Truck } from 'lucide-react';
export function NotFound() {
  return <main className="min-h-[calc(100vh-64px)] bg-[#f3f0ec] dark:bg-[#292827] flex items-center justify-center px-4 transition-colors duration-300" data-id="element-2217">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5
    }} className="text-center max-w-md" data-id="element-2218">
        <div className="w-20 h-20 bg-brand-orange/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-2219">
          <Truck className="w-10 h-10 text-brand-orange" data-id="element-2220" />
        </div>

        <h1 className="font-heading text-6xl md:text-7xl font-extrabold text-stone-900 dark:text-white mb-3 tracking-tight" data-id="element-2221">
          404
        </h1>
        <p className="text-lg text-stone-600 dark:text-stone-300 mb-8 font-sub" data-id="element-2222">
          This page must've taken a wrong turn. Let's get you back on track.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-2223">
          <Link to="/" className="inline-flex items-center justify-center px-6 py-3 bg-brand-button hover:bg-brand-buttonHover text-white rounded-xl font-bold text-sm transition-colors" data-id="element-2224">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2225" />
            Back to Home
          </Link>
          <a href="tel:206-619-3742" className="inline-flex items-center justify-center px-6 py-3 border border-stone-300 dark:border-white/20 text-stone-900 dark:text-white rounded-xl font-bold text-sm hover:bg-stone-100 dark:hover:bg-white/5 transition-colors" data-id="element-2226">
            Call (206) 619-3742
          </a>
        </div>
      </motion.div>
    </main>;
}